<script lang="ts" setup>
import { hostBaseUrl } from '@/utils/env';
import { computed, withDefaults } from 'vue'
const props = withDefaults(defineProps<{
  initials: string;
  imagePath?: string;
  currentUser?: boolean;
}>(), {
  imagePath: undefined,
  currentUser: false,
})

const fullImagePath = computed(() => {
  if (!props.imagePath) {
    return undefined
  }
  const imagePath = props.imagePath?.[0] !== '/' ? props.imagePath : `${hostBaseUrl()}${props.imagePath}`
  return imagePath
})
</script>

<style scoped lang="scss">
#user-avatar-you-label {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  line-height: 1;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>

<template>
  <div class="position-relative w-40">
    <div
      id="user-avatar-container"
      class="d-flex margin-r-4 w-40 h-40 border-radius-round align-center justify-center text-white font-medium overflow-hidden"
      :class="[
        imagePath ? 'background-cover background-center' : 'background-gray-mid-light',
        { 'border-2 border-solid border-midnight-gray-300': currentUser }
      ]"
      :style="fullImagePath ? { backgroundImage: `url(${fullImagePath})`, backgroundSize: 'cover', objectFit: 'cover' } : {}"
    >
      <span id="user-avatar-initials" v-if="!imagePath">{{ initials }}</span>
    </div>
    <div
      v-if="currentUser"
      id="user-avatar-you-label"
      class="position-absolute background-midnight-gray-300 text-white font-10 font-medium padding-x-1 border-radius-4"
    >
      You
    </div>
  </div>
</template>
